import React, { useEffect, useState } from "react";
import { ConfigItem } from "./ConfigItem";
import {
  Card,
  CardHeader,
  CardTitle,
  CardBody,
  Col,
  Row,
  FormGroup,
  Form,
  Input,
  Button,
  Modal,
} from "react-bootstrap";
//import Radio from 'components/atoms/@vuexy/radio/RadioVuexy'
//import Checkbox from 'components/atoms/@vuexy/checkbox/CheckboxesVuexy'
import { Checkbox, Radio, FormControlLabel } from "@mui/material";
//import { Check, Minus, Search, Save } from 'react-feather'
import FeatherIcon from "feather-icons-react";
import FolderCopyIcon from "@mui/icons-material/FolderCopy";
import GroupsIcon from "@mui/icons-material/Groups";
import Select, { components } from "react-select";
import Icon from "./Icon";
import PermissionGroup from "components/Modal/PermissionGroup";
import FolderMenu from "components/Modal/FolderMenu";
import httpClient from "utility/httpClient.util";
import Editor, { useMonaco, OnMount } from "@monaco-editor/react";
import _ from "lodash";
import Swal from "sweetalert2";

const { Option } = components;

const IconOption = (props) => (
  <Option {...props}>
    {props.data.iconName && <Icon name={props.data.iconName} />}
    <span style={{ marginLeft: "5px" }}>{props.data.label}</span>
  </Option>
);

const ExportImportMenu = (props) => {
  const [show, setShow] = useState(false);
  const [showExport, setShowExport] = useState(false);
  const [showImport, setShowImport] = useState(false);
  const [exportJson, setExportJson] = useState("");
  const [importJson, setImportJson] = useState("");
  const [exportName, setExportName] = useState("");
  const [isExporting, setIsExporting] = useState(false);
  const [isImporting, setIsImporting] = useState(false);
  const exportOnly = props?.exportOnly === true;
  const exportButtonLabel = props?.exportButtonLabel || "Export Json";
  const importButtonLabel = props?.importButtonLabel || "Import Json";
  const exportButtonStyle = props?.exportButtonStyle || { width: "100%" };
  const exportButtonClassName =
    props?.exportButtonClassName || "btn btn-warning mb-2";

  let editorRef;

  const handleEditorMount: OnMount = (editor, monaco) => {
    editorRef = editor;

    // Auto-collapse second level after the editor mounts
    collapseSecondLevel(editor);
  };

  const collapseSecondLevel = (editor) => {
    const model = editor.getModel();
    if (!model) return;

    const lineCount = model.getLineCount();

    for (let lineNumber = 1; lineNumber <= lineCount; lineNumber++) {
      const level = editor
        .getFoldedLineRanges()
        ?.find((range) => range.start <= lineNumber && range.end >= lineNumber);

      // Or check indentation for JSON / JS
      const indent = model.getLineFirstNonWhitespaceColumn(lineNumber) - 1;

      if (indent === 2) {
        // second-level: indentation 2 (adjust as needed)
        editor.setFolded(lineNumber, true); // collapse this line
      }
    }
  };

  //const [state,setState] = useState(Object.assign({moduleName:'',publishAt:"",locationCode:"",printStyle:false,exportExcel:false},props.publish))
  const state = props.publish;

  console.log("exportMenu", state);

  const ExportModal = ({ show, onHide = () => {} }) => {
    const onCopyJson = () => {
      navigator.clipboard
        .writeText(exportJson)
        .then(() => {
          Swal.fire({
            icon: "success",
            title: "Copied!",
            text: "JSON has been copied to clipboard.",
            timer: 1500,
            showConfirmButton: false,
          });
        })
        .catch((err) => {
          Swal.fire({
            icon: "error",
            title: "Failed!",
            text: "Could not copy JSON.",
          });
          console.error("Copy failed:", err);
        });
    };

    const onDownloadJson = () => {
      if (!exportJson) return;

      // Create a blob with JSON MIME type
      const blob = new Blob([exportJson], { type: "application/json" });

      // Create a temporary link
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = exportName + ".json"; // filename

      // Trigger download
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      // Release object URL
      URL.revokeObjectURL(url);
    };

    return (
      <Modal show={show} dialogClassName="modal-100w" onHide={() => onHide()}>
        <Modal.Header className="bg-primary" closeButton>
          Export Management
        </Modal.Header>
        <Modal.Body row>
          <Row>
            <Col>
              <FormGroup>
                <Form.Label for="exampleText">JSON </Form.Label>
                <Editor
                  className="monaco-editor-custom"
                  height="calc(100vh - 230px)"
                  defaultLanguage="javascript" // Set the default language as JavaScript
                  defaultValue="// Start typing JavaScript code here"
                  value={exportJson}
                  options={{
                    fontSize: 14, // Set the desired font size
                    tabSize: 2,
                    automaticLayout: true, // auto resize
                    formatOnPaste: true,
                    formatOnType: true,
                  }}
                  onChange={(newValue, e) => {
                    //   console.log('e', e)
                    //updateData('query', newValue)
                  }}
                />
              </FormGroup>
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer row>
          <Button onClick={() => onCopyJson()} className="btn btn-success mr-1">
            <FeatherIcon size="16" icon="copy" className="vx-icon mr-1" />
            Copy to Clipboard
          </Button>
          <Button
            color="primary"
            onClick={() => onDownloadJson()}
            className="mr-1"
          >
            <FeatherIcon size="16" icon="download" className="vx-icon mr-1" />
            Download
          </Button>
          <Button variant="default" onClick={() => onHide()}>
            <FeatherIcon size="16" icon="x" className="vx-icon mr-1" />
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    );
  };

  const ImportModal = ({ show, onHide = () => {} }) => {
    const onPasteJson = async () => {
      try {
        const text = await navigator.clipboard.readText();
        // Do something with the text, e.g., set it in Monaco
        setImportJson(text);
        Swal.fire({
          icon: "success",
          title: "Pasted!",
          text: "Text has been pasted from clipboard.",
          timer: 1500,
          showConfirmButton: false,
        });
      } catch (err) {
        console.error("Failed to read clipboard: ", err);
        Swal.fire({
          icon: "error",
          title: "Failed!",
          text: "Could not read from clipboard.",
        });
      }
    };

    const onUploadJson = (event) => {
      const file = event.target.files[0];
      if (!file) return;

      const reader = new FileReader();
      reader.onload = (e) => {
        try {
          const text = e.target.result;
          // Optionally validate JSON
          JSON.parse(text);
          setImportJson(text); // set as Monaco value
          Swal.fire({
            icon: "success",
            title: "Uploaded!",
            text: `${file.name} has been loaded.`,
            timer: 1500,
            showConfirmButton: false,
          });
        } catch (err) {
          Swal.fire({
            icon: "error",
            title: "Invalid JSON",
            text: "The uploaded file is not valid JSON.",
          });
        }
      };
      reader.readAsText(file);
    };

    return (
      <Modal show={show} dialogClassName="modal-100w" onHide={() => onHide()}>
        <Modal.Header className="bg-primary" closeButton>
          Import Management
        </Modal.Header>
        <Modal.Body row>
          <Row>
            <Col>
              <FormGroup>
                <Form.Label for="exampleText">JSON </Form.Label>
                <Editor
                  className="monaco-editor-custom"
                  height="calc(100vh - 230px)"
                  defaultLanguage="javascript" // Set the default language as JavaScript
                  defaultValue="// Start typing JavaScript code here"
                  value={importJson}
                  options={{
                    fontSize: 14, // Set the desired font size
                    tabSize: 2,
                    automaticLayout: true, // auto resize
                    formatOnPaste: true,
                    formatOnType: true,
                  }}
                  onChange={(newValue, e) => {
                    setImportJson(newValue || "");
                  }}
                />
              </FormGroup>
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer>
          <Row className="w-100 m-0">
            {/* Left side buttons */}
            <Col className="d-flex align-items-center">
              <Button
                onClick={() => onPasteJson()}
                className="btn btn-success mr-1"
              >
                <FeatherIcon
                  size="16"
                  icon="clipboard"
                  className="vx-icon mr-1"
                />
                Paste from Clipboard
              </Button>

              <input
                type="file"
                accept=".json,application/json"
                style={{ display: "none" }}
                id="uploadJsonInput"
                onChange={onUploadJson}
              />

              <Button
                variant="secondary"
                onClick={() =>
                  document.getElementById("uploadJsonInput").click()
                }
              >
                <FeatherIcon size="16" icon="upload" className="vx-icon mr-1" />
                Upload JSON
              </Button>
            </Col>

            {/* Right side buttons */}
            <Col className="d-flex justify-content-end align-items-center">
              <Button
                color="primary"
                disabled={isImporting}
                onClick={async () => {
                  try {
                    setIsImporting(true);
                    const isApplied = await props?.onApply(JSON.parse(importJson));
                    if (isApplied !== false) onHide();
                  } catch (error) {
                    Swal.fire({
                      icon: "error",
                      title: "Import ไม่สำเร็จ",
                      text:
                        error?.response?.data?.message ||
                        error?.message ||
                        "ไม่สามารถนำเข้า JSON ได้",
                    });
                  } finally {
                    setIsImporting(false);
                  }
                }}
                className="mr-1"
              >
                <FeatherIcon size="16" icon="save" className="vx-icon mr-1" />
                {isImporting ? "Importing..." : "Apply"}
              </Button>

              <Button
                variant="default"
                disabled={isImporting}
                onClick={() => onHide()}
              >
                <FeatherIcon size="16" icon="x" className="vx-icon mr-1" />
                Close
              </Button>
            </Col>
          </Row>
        </Modal.Footer>
      </Modal>
    );
  };

  const onShowExport = async () => {
    setIsExporting(true);

    try {
      const jsonData = await Promise.resolve(
        props?.getExportJsonData
          ? props.getExportJsonData()
          : props?.getJsonData(),
      );

      jsonData["webviewData"] = _.omit(jsonData.webviewData, [
        "reportTemplateId",
        "reportWebviewId",
      ]);

      setExportName(jsonData?.templateData?.name || "export");
      setExportJson(JSON.stringify(jsonData, null, 2));
      setShowExport(true);
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Export ไม่สำเร็จ",
        text:
          error?.response?.data?.message ||
          error?.message ||
          "ไม่สามารถ export JSON ได้",
      });
    } finally {
      setIsExporting(false);
    }
  };

  return (
    <div>
      <Button
        style={exportButtonStyle}
        className={exportButtonClassName}
        onClick={onShowExport}
        disabled={isExporting}
      >
        <FeatherIcon size="16" icon="share" className="vx-icon" />{" "}
        {isExporting ? "Exporting..." : exportButtonLabel}
      </Button>

      {!exportOnly && (
        <Button
          style={{ width: "100%" }}
          className="btn btn-success"
          onClick={() => setShowImport(true)}
        >
          <FeatherIcon size="16" icon="download" className="vx-icon" />{" "}
          {importButtonLabel}
        </Button>
      )}
      <ExportModal show={showExport} onHide={() => setShowExport(false)} />
      {!exportOnly && (
        <ImportModal show={showImport} onHide={() => setShowImport(false)} />
      )}
    </div>
  );
};

export default ExportImportMenu;
